import * as types from '../constants/actionTypes';
import initialState from './initialState';
import Immutable from 'seamless-immutable';
import { APPROVAL_STATUS, VALIDATIONS_DATAKEY } from '../constants/constants';

/* Note */
/* Params: isLoadMore to check user have load more yet */
export default function validationReducer(state = initialState.validations, action) {
  switch (action.type) {
    case types.GET_VALIDATION_SUCCESS: {
      const { myValidation, validationSent } = Immutable.asMutable(state);
      const { dataKey } = action;
      let updateParams = {};
      if (dataKey === VALIDATIONS_DATAKEY.MY_VALIDATIONS) {
        const newMyValidation = action.params && action.params.isLoadMore ? [...myValidation, ...action.data.data] : action.data.data;
        updateParams = {
          isLoadingMyValidation: false,
          isCalledMyValidation: true,
          myValidation: newMyValidation,
          isHasMoreMyValidations: newMyValidation.length < action.data.total,
        };
      }
      if (dataKey === VALIDATIONS_DATAKEY.VALIDATION_SENT) {
        const newValidationSent = action.params && action.params.isLoadMore ? [...validationSent, ...action.data.data] : action.data.data;
        updateParams = {
          isLoadingValidationSent: false,
          isCalledValidationSent: true,
          validationSent: newValidationSent,
          isHasMoreValidationSent: newValidationSent.length < action.data.total,
        };
      }
      return state.merge({ ...updateParams });
    }
    case types.UPDATE_VALIDATION_STATE: {
      return state.merge({ ...action.data });
    }
    case types.DELETE_VALIDATION_SUCCESS: {
      const { myValidation, validationSent } = Immutable.asMutable(state);
      const { dataKey } = action;
      let updateParams = {};
      if (dataKey === VALIDATIONS_DATAKEY.MY_VALIDATIONS) {
        updateParams = {
          myValidation: myValidation.filter(item => item.listId !== action.id),
        };
      }
      if (dataKey === VALIDATIONS_DATAKEY.VALIDATION_SENT) {
        updateParams = {
          validationSent: validationSent.filter(item => item.listId !== action.id),
        };
      }
      return state.merge({ ...updateParams });
    }
    case types.APPROVE_VALIDATION_SUCCESS: {
      const { myValidation } = Immutable.asMutable(state);
      if (myValidation && myValidation.length > 0) {
        myValidation.forEach((itm, idx) => {
          if (itm.listId === action.id) {
            state = state.setIn(['myValidation', idx, 'approvalState'], APPROVAL_STATUS.APPROVED);
          }
        });
      }
      return state;
    }

    case types.USER_LOGOUT_SUCCESS: {
      const reset = {
        myValidation: [],
        validationSent: [],
        pageMyValidations: 1,
        pageValidationSent: 1,
        isLoadingMyValidation: false,
        isLoadingValidationSent: false,
        isHasMoreMyValidations: true,
        isHasMoreValidationSent: true,
      };
      return state.merge({
        ...reset,
      });
    }

    case types.RESET_ALL_DATA: {
      return state.merge({
        isLoadingMyValidation: false,
        isCalledMyValidation: false,
        myValidation: [],
        isHasMoreMyValidations: true,
        isLoadingValidationSent: false,
        isCalledValidationSent: false,
        validationSent: [],
        isHasMoreValidationSent: true,
      });
    }

    default:
      return state;
  }
}
